import { render, staticRenderFns } from "./ExtensionsIcon.vue?vue&type=template&id=3cc7802e&"
import script from "./ExtensionsIcon.vue?vue&type=script&lang=js&"
export * from "./ExtensionsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports